<app-slim-topbar *ngIf="guest"></app-slim-topbar>
<div class="layout-content p-0 mb-5 mt-3" [ngClass]="layoutMarginResponsive()">
	<div *ngIf="guest" class="flex align-items-center justify-content-center w-full font-semibold text-2xl my-3">
		{{'CALCULATION_POWER_PAGE_TITLE' | translate }}
	</div>
	<div class="card">
		<div class="flex flex-row align-items-center justify-content-center my-3 gap-3">
			<div class="flex flex-column">
				<div class="text-start">{{ 'BUS_SELECT_PANEL' | translate }}</div>
				<div class="flex flex-row align-items-center gap-4">
					<p-dropdown [options]="listBus" [(ngModel)]="busSelect" (onChange)="busChange()" class="w-15rem h-2rem"
						styleClass="w-15rem h-2rem">
						<ng-template let-item pTemplate="selectedItem">
							<div class="item" class="flex align-items-center justify-content-center">
								<div class="flex justify-content-center">{{ item.name }}</div>
							</div>
						</ng-template>
						<ng-template let-item pTemplate="item">
							<div class="item flex align-items-center justify-content-center">
								<div>{{ item.name }}</div>
							</div>
						</ng-template>
					</p-dropdown>
				</div>
			</div>
			<div class="flex flex-row align-items-center justify-content-center gap-2 pt-4">
				<p-inputSwitch [(ngModel)]="enableGreenPower" (onChange)="busChange()"/>
				<div class="pb-1">{{ 'BUS_ENABLE_GREEN_POWER' | translate }}</div>
			</div>
		</div>

		<div *ngIf="maxGateway>0" class="grid mt-0">
			<!------------------ Gateway -->
			<div class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'GATEWAY' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalGateway === maxGateway}">
						max: {{totalGateway}}/{{maxGateway}}
					</span>
				</div>
				<div class="flex flex-row align-items-center justify-content-between" *ngFor="let gateway of listGateway">
					<div class="flex flex-column justify-content-start">
						<span>{{ gateway.name | translate }}</span>
						<div class="text-sm" [class]="canAddAlertVisibleDevice(gateway)">{{ 'BUS_POWER' | translate }}:{{gateway.power}}w</div>
					</div>
					<div class="flex flex-row align-items-center gap-2">
						<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
							[disabled]="gateway.disableRemove || checkSelectable(gateway)" tooltipPosition="bottom"
							icon="pi cm-minus" size="large" (click)="subtractOne(gateway)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
						<strong>{{ gateway.quantity }}</strong>
						<p-button pTooltip="{{ 'ADD' | translate}}"
							[disabled]="gateway.disableAdd || checkSelectable(gateway)" tooltipPosition="bottom"
							icon="pi cm-plus" size="large" (click)="addOne(gateway)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
					</div>
				</div>
			</div>
			<!------------------ Schede -->
			<div *ngIf="maxSchede>0" class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_SCHEDE' | translate }}</div>
					<span class="mr-4"></span>
				</div>
				<div class="flex flex-row align-items-center justify-content-between" *ngFor="let schede of listSchede">
					<div class="flex flex-column justify-content-start">
						<span><i class="pi pi-rectangle mr-2"></i>{{ schede.name | translate }}</span>
						<div class="text-sm" [class]="canAddAlertVisibleDevice(schede)">{{ 'BUS_POWER' | translate}}: {{schede.power}}w</div>
					</div>
					<div class="flex flex-row align-items-center gap-2">
						<p-button pTooltip="{{ 'SUBTRACT' | translate }}"
							[disabled]="schede.disableRemove || checkSelectable(schede)" tooltipPosition="bottom"
							icon="pi cm-minus" size="large" (click)="subtractOne(schede)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
						<strong>{{ schede.quantity }}</strong>
						<p-button pTooltip="{{ 'ADD' | translate }}"
							[disabled]="schede.disableAdd || checkSelectable(schede)" tooltipPosition="bottom"
							icon="pi cm-plus" size="large" (click)="addOne(schede)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
					</div>
				</div>
			</div>
			<!------------------ Selettori -->
			<div *ngIf="maxSelettoriBus>0" class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_SELECTORS_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalSelettoriBus === maxSelettoriBus}">max:
						{{totalSelettoriBus}}/{{maxSelettoriBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between" *ngFor="let selettore of listSelettoriBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ selettore.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(selettore)">{{ 'BUS_POWER'
								|
								translate}}:
								{{selettore.power}}w</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
								[disabled]="selettore.disableRemove || checkSelectable(selettore)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(selettore)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
							<strong>{{ selettore.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="selettore.disableAdd || checkSelectable(selettore)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(selettore)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<!-- COLL -->
			<div *ngIf="totalLampeggiantiBus>0 || totalInterfaccieBus>0 || totalFotocelluleBus>0" class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<!------------------ Fotocellule -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_PHOTOCELLS_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalFotocelluleBus === maxFotocelluleBus}">max:
						{{totalFotocelluleBus}}/{{maxFotocelluleBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let fotocellula of listFotocelluleBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ fotocellula.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(fotocellula)">{{
								'BUS_POWER' |
								translate}}:
								{{fotocellula.power}}w</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
								[disabled]="fotocellula.disableRemove || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(fotocellula)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ fotocellula.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="fotocellula.disableAdd || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(fotocellula)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Interfaccie -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_INTERFACES_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalInterfaccieBus === maxInterfaccieBus}">max:
						{{totalInterfaccieBus}}/{{maxInterfaccieBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let interfaccia of listInterfaccieBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ interfaccia.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(interfaccia)">{{
								'BUS_POWER' |
								translate}}:
								{{interfaccia.power}}w</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
								[disabled]="interfaccia.disableRemove || checkSelectable(interfaccia)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(interfaccia)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ interfaccia.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="interfaccia.disableAdd || checkSelectable(interfaccia)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(interfaccia)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div><!------------------ Lampeggianti -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_FLASHING_BUS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalLampeggiantiBus === maxLampeggiantiBus}">max:
						{{totalLampeggiantiBus}}/{{maxLampeggiantiBus}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let lampeggiante of listLampeggiantiBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ lampeggiante.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(lampeggiante)">{{
								'BUS_POWER' |
								translate}}:
								{{lampeggiante.power}}w</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
								[disabled]="lampeggiante.disableRemove || checkSelectable(lampeggiante)"
								tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="subtractOne(lampeggiante)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ lampeggiante.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="lampeggiante.disableAdd || checkSelectable(lampeggiante)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(lampeggiante)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<!-- COLL -->
			<div *ngIf="maxFotocelluleOld>0 || maxSelettoriOld>0" class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<!------------------ Selettori -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_SELECTOR' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalSelettoriOld === maxSelettoriOld}">max:
						{{totalSelettoriOld}}/{{maxSelettoriOld}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let selettori of listSelR">
						<div class="flex flex-column justify-content-start">
							<span>{{ selettori.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(selettori)">{{
								'BUS_POWER' |
								translate}}:
								{{selettori.power}}w</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
								[disabled]="selettori.disableRemove || checkSelectable(selettori)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(selettori)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
							<strong>{{ selettori.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="selettori.disableAdd || checkSelectable(selettori)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(selettori)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Fotocellule -->
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_PHOTOCELLS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalFotocelluleOld === maxFotocelluleOld}">max:
						{{totalFotocelluleOld}}/{{maxFotocelluleOld}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let fotocellula of listFotocell">
						<div class="flex flex-column justify-content-start">
							<span>{{ fotocellula.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(fotocellula)">{{
								'BUS_POWER' |
								translate}}:
								{{fotocellula.power}}w</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
								[disabled]="fotocellula.disableRemove || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(fotocellula)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ fotocellula.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="fotocellula.disableAdd || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(fotocellula)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid mt-0">
			<div [class]="col12Responsive()" class="flex justify-content-center">
				<div class="flex flex-column justify-content-center">
					<div class="flex flex-row align-items-center">
						<div class="w-11rem mr-2 text-xl font-semibold">{{ 'BUS_TOTAL_LOAD' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-xl font-semibold">(w)</div>
					</div>
					<div class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: black;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_PANEL' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalBoard}}</div>
					</div>
					<div *ngIf="maxGateway > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: red;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'GATEWAY' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadGateway}}</div>
					</div>
					<div *ngIf="maxSchede > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: purple;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_BOARD' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadSchede}}</div>
					</div>
					<div *ngIf="maxSelettoriBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: green;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_SELECTORS_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadSelettoriBus}}</div>
					</div>
					<div *ngIf="maxFotocelluleBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: orange;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_PHOTOCELLS_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadFotocelluleBus}}</div>
					</div>
					<div *ngIf="maxInterfaccieBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: blue;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_INTERFACES_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadInterfaccieBus}}</div>
					</div>
					<div *ngIf="maxLampeggiantiBus > 0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: pink;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_FLASHING_BUS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadLampeggiantiBus}}</div>
					</div>
					<div *ngIf="maxSelettoriOld>0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: green;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_SELECTORS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadSelettoriOld}}</div>
					</div>
					<div *ngIf="maxFotocelluleOld>0" class="flex flex-row align-items-center mt-3">
						<div class="w-1rem h-2rem border-round-lg" style="background-color: orange;"></div>
						<div class="ml-2 w-10rem text-lg">{{ 'BUS_PHOTOCELLS' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadFotocelluleOld}}</div>
					</div>
					<div class="flex flex-row align-items-center mt-3">
						<div class="w-11rem mr-2 text-xl font-semibold"> {{ 'BUS_TOTAL_POWER' | translate }}</div>
						<div class="w-4rem flex justify-content-center text-xl font-semibold">{{totalPower}}</div>
					</div>
				</div>
			</div>
			<div [class]="col12Responsive()" class="flex justify-content-center">
				<div class="flex flex-column gap-2">
					<div class="flex flex-row text-xl font-semibold pb-2">Potenza Totale Quadro 40W</div>
					<p-meterGroup [value]="valuePower" labelPosition="end"/>
					<div class="flex flex-row text-xl font-semibold pb-2">Potenza Massima Green Power 2W</div>
					<p-meterGroup [value]="valueGreenPower" />
					<div class="flex flex-row text-xl font-semibold pb-2">Potenza Normativa attuale 8W</div>
					<p-meterGroup [value]="valueCalcPower" />
					<div class="flex flex-row text-xl font-semibold pb-2">Calcolo Bus 15W</div>
					<p-meterGroup [value]="valueCalcPower" />
				</div>
			</div>
		</div>
	</div>
</div>
<app-buscalculation-footer *ngIf="guest"></app-buscalculation-footer>